import { render, staticRenderFns } from "./AuthResetPassword.vue?vue&type=template&id=086c2126&scoped=true"
import script from "./AuthResetPassword.vue?vue&type=script&lang=ts"
export * from "./AuthResetPassword.vue?vue&type=script&lang=ts"
import style0 from "./AuthResetPassword.vue?vue&type=style&index=0&id=086c2126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c2126",
  null
  
)

export default component.exports